import Grid from "../../../Grid";
import React, {useCallback, useEffect, useRef, useState} from "react";
import Modal from "../../../Modal";
import {
    getJobCurrentStatus,
    timeUpdateByJobId,
    updateLocationTime,
} from "../../../../api/jobApi";
import LoadingSpinner from "../../../LoadingSpinner";
import PopUpDateTimePicker from "../../../input/PopUpDateTimePicker";
import {
    addMinutesToDate,
    formatFromJsonDate,
    isAfter,
    isAfterJson,
    isBefore,
    subtractMinutesToDate,
} from "../../../../dateConfig";
import InputRenderer from "../../../renderer/InputRenderer";
import {toast} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {getTextByValueAndKey} from "../../../../api/keyvalue";
import LocationDetails from "../../LocationDetails";
import InfoList from "../../../InfoList";
import {useSelector} from "react-redux";
import StatusLabel from "../../../input/StatusLabel";
import {ResizableScrollingTextRenderer} from "../../../renderer/StyleRenderer";
import {CONFIGS, FORMS, MODULES, STATUS_GROUPS} from "../../../../const";
import {getFieldAuthority} from "../../../../auth/authHelper";
import {stakeholderConfigByStakeholderAndConfig} from "../../../../api/stakeholderapi";
import {statusIdsByContexts} from "../../../../api/statusApi";
import {errorMessageToast} from "../../../../helper";
import {geofenceTimeByRtuId} from "../../../../api/geofenceTime";

const LOCATIONNOTUPDATEDFLAG = "Not updated";

const TimeUpdate = ({
                        jobId,
                        customerId,
                        timeUpdateViewMode,
                        jobInfo,
                        jobStatus,
                        jobStatusColor,
                    }) => {
    const auth = useSelector(
        (state) => state.user.permissions[MODULES.Transaction],
    );
    const user = useSelector((state) => state.user);
    const [popUpContent, setPopUpContent] = useState(null);
    const [currentLocation, setCurrentLocation] = useState(null);
    const [jobLocations, setJobLocations] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [currentArrivalDate, setCurrentArrivalDate] = useState(null);
    const [currentDepartureDate, setCurrentDepartureDate] = useState(null);
    const [currentGeoArrivalDate, setCurrentGeoArrivalDate] = useState(null);
    const [lastDepartureDate, setLastDepatueDate] = useState(null);
    const [lastDepartureSeq, setLastDepatueSeq] = useState(null);
    const [currentId, setCurrentId] = useState(null);
    const [currentSeq, setCurrentSeq] = useState(null);
    const [popUpKey, setPopUpKey] = useState(1);
    const [timeGapInMins, setTimeGapInMins] = useState(10);
    const [vnaList, setVnaList] = useState([]);
    const [currentStatus, setCurrentStatus] = useState(jobStatus);
    const [currentStatusColor, setCurrentStatusColor] = useState(jobStatusColor);
    const [editDisabledStatus, setEditDisabledStatus] = useState([]);
    const [geoArrivalList, setGeoArrivalList] = useState([]);
    const [geoDepartureList, setGeoDepartureList] = useState([]);

    console.log("LOCATIONS: ", jobLocations);
    const chooseTime_select = 1;
    const chooseTime_suggest = 2;

    useEffect(() => {
        setCurrentStatus(jobStatus);
        setCurrentStatusColor(jobStatusColor);
    }, [jobStatus, jobStatusColor]);

    const formatDateTime = (date) => {
        if (!date) return "";

        const d = new Date(date);

        const yyyy = d.getFullYear();
        const mm = String(d.getMonth() + 1).padStart(2, "0");
        const dd = String(d.getDate()).padStart(2, "0");
        const hh = String(d.getHours()).padStart(2, "0");
        const min = String(d.getMinutes()).padStart(2, "0");

        return `${yyyy}/${mm}/${dd} ${hh}:${min}`;
    };

    const jobInformation = [
        {
            title: "Request",
            value: jobInfo.reqCode,
        },
        {
            title: "Job",
            value: jobInfo.jobCode,
        },
        {
            title: "Plant",
            value: jobInfo.plant,
        },
        {
            title: "Invoicing Customer",
            value: jobInfo.invoicingCustomer,
        },
        {
            title: "Customer",
            value: jobInfo.customer,
        },
        {
            title: "Current Status",
            value: <StatusLabel status={currentStatus} color={currentStatusColor}/>,
        },
        {
            title: "CBM",
            value: jobInfo.cbm,
        },
        {
            title: "Vehicle Type",
            value: jobInfo.vehicleType,
        },
        {
            title: "Vehicle",
            value: jobInfo.vehicle,
        },
        {
            title: "Driver",
            value: jobInfo.driver,
        },
        {
            title: "Helper",
            value: jobInfo.helper,
        },
        {
            title: "Transporter",
            value: jobInfo.transporter,
        },
        {
            title: "Approved Date",
            value: jobInfo.approvedDate,
        },
        {
            title: "Booking Required Date",
            value: jobInfo.bookingRequiredDate,
        },
        {
            title: "Created Date",
            value: jobInfo.createdDate,
        },
        {
            title: "Created By",
            value: jobInfo.createdBy,
        },
        {
            title: "Return Remarks",
            value: jobInfo.returnRemark,
        },
    ];

    const mapLocations = useCallback(async (response) => {
        if (response && response.length > 0) {
            let index = 2;
            const mappedLocations = [];
            let lastLocationDepatureDate = null;
            let lastDepatureActualSeq = null;
            for (let location of response) {
                const rlkLocationTypeValue = await getTextByValueAndKey(
                    "rlk_location",
                    location.rlkLocationType,
                );
                if (
                    location.rtuDepartureTime &&
                    location.rtuDepartureTime !== LOCATIONNOTUPDATEDFLAG
                ) {
                    if (lastLocationDepatureDate === null) {
                        lastLocationDepatureDate = location.rtuDepartureTime;
                        lastDepatureActualSeq = location.actualSeq;
                    } else {
                        if (
                            isAfterJson(location.rtuDepartureTime, lastLocationDepatureDate)
                        ) {
                            lastLocationDepatureDate = location.rtuDepartureTime;
                            lastDepatureActualSeq = location.actualSeq;
                        }
                    }
                }
                mappedLocations.push({
                    ...location,
                    rlkLocationTypeValue,
                    id: index++,
                    gRlkArrivalEta: location.rlkArrivalEta
                        ? formatFromJsonDate(location.rlkArrivalEta)
                        : "N/A",
                    gRlkDepartureEta: location.rlkDepartureEta
                        ? formatFromJsonDate(location.rlkDepartureEta)
                        : "N/A",
                    rtuArrivalTime: location.rtuArrivalTime
                        ? formatFromJsonDate(location.rtuArrivalTime)
                        : LOCATIONNOTUPDATEDFLAG,
                    rtuDepartureTime: location.rtuDepartureTime
                        ? formatFromJsonDate(location.rtuDepartureTime)
                        : LOCATIONNOTUPDATEDFLAG,
                    rtuArrivalTimeNonFormat: location.rtuArrivalTime,
                    rtuDepartureTimeNonFormat: location.rtuDepartureTime,
                });
            }
            setJobLocations(mappedLocations);
            setLastDepatueDate(lastLocationDepatureDate);
            setLastDepatueSeq(lastDepatureActualSeq);
        } else {
            setJobLocations([]);
            setLastDepatueDate(null);
        }
    }, []);

    useEffect(() => {
        (async () => {
            setIsLoading(true);
            const currentJobLocations = await timeUpdateByJobId(jobId);
            const timeGapConfig = await stakeholderConfigByStakeholderAndConfig(
                customerId,
                CONFIGS.REQUEST_ARRIVAL_TIME_GAP,
            );
            if (timeGapConfig) {
                setTimeGapInMins(timeGapConfig.scnNumber);
            }

            const {
                [STATUS_GROUPS.VEHICLE_NOT_ASSIGNED]: mappedVNAList = [],
                [STATUS_GROUPS.JOB_EDIT_DISABLED]: jobEditDisabledStatus = [],
            } = await statusIdsByContexts([
                STATUS_GROUPS.VEHICLE_NOT_ASSIGNED,
                STATUS_GROUPS.JOB_EDIT_DISABLED,
            ]);

            setEditDisabledStatus(jobEditDisabledStatus);
            setVnaList(mappedVNAList);
            await mapLocations(currentJobLocations);
            setIsLoading(false);
        })();
    }, [customerId, jobId, mapLocations]);

    const updateTime = async (id, value, timeType, chooseTimeType) => {
        setIsLoading(true);
        const currentLocation = jobLocations.find((location) => location.id === id);

        if (
            timeType === "A" &&
            isAfterJson(
                addMinutesToDate(value, timeGapInMins),
                currentLocation.rtuDepartureTimeNonFormat,
            )
        ) {
            toast.error("Date should be before departure date and time gap", {
                containerId: "Modal",
                autoClose: 3000,
            });
            setIsLoading(false);
            return;
        }

        if (
            timeType === "D" &&
            isAfterJson(
                addMinutesToDate(
                    currentLocation.rtuArrivalTimeNonFormat,
                    timeGapInMins,
                ),
                value,
            )
        ) {
            toast.error("Date should be after Arrival date and time gap", {
                containerId: "Modal",
                autoClose: 3000,
            });
            setIsLoading(false);
            return;
        }

        if (currentLocation.actualSeq > 1) {
            const prevLocation = jobLocations.find(
                (location) => location.actualSeq === currentLocation.actualSeq - 1,
            );
            if (
                timeType === "A" &&
                isAfterJson(
                    prevLocation.rtuDepartureTimeNonFormat,
                    subtractMinutesToDate(value, timeGapInMins),
                )
            ) {
                toast.error(
                    "Date should be after previous location departure date and time gap",
                    {
                        containerId: "Modal",
                        autoClose: 3000,
                    },
                );
                setIsLoading(false);
                return;
            }
        }

        if (currentLocation.actualSeq > 0) {
            const nextLocation = jobLocations.find(
                (location) => location.actualSeq === currentLocation.actualSeq + 1,
            );

            if (
                timeType === "D" &&
                nextLocation &&
                isAfterJson(
                    addMinutesToDate(value, timeGapInMins),
                    nextLocation.rtuArrivalTimeNonFormat,
                )
            ) {
                toast.error(
                    "Date should be before next location arrival date and time gap",
                    {
                        containerId: "Modal",
                        autoClose: 3000,
                    },
                );
                setIsLoading(false);
                return;
            }
        }

        modalRef.current.close();
        try {
            const response = await updateLocationTime({
                username: user.username,
                job: currentLocation.rtuJobId,
                request: currentLocation.rtuRequest,
                id: currentLocation.rtuRlkId,
                rtuId: currentLocation.rtuId,
                rtuStatusName: currentLocation.rtuStatusName,
                timeType,
                time: value,
                auto: "1",
                type: "1",
                chooseTimeType: chooseTimeType,
            });

            if (response.some((location) => location.rtuId < 0)) {
                const locationWithError = response.find(
                    (location) => location.rtuId < 0,
                );
                toast.error(locationWithError.rtuStatusName, {
                    containerId: "Main",
                    autoClose: 3000,
                });
                setIsLoading(false);
                return;
            }
            const jobCurrentStatus = await getJobCurrentStatus(jobId);

            await mapLocations(response);

            setCurrentStatus(jobCurrentStatus?.staName);
            setCurrentStatusColor(jobCurrentStatus?.staColor);

            toast.success(
                `Successfully updated the ${
                    timeType === "A" ? "arrival" : "depature"
                } time`,
                {containerId: "Main", autoClose: 3000},
            );
        } catch (e) {
            errorMessageToast(e);
        }
        setIsLoading(false);
    };

    const findFirstLocation = () =>
        jobLocations.find((loc) => loc.rlkLocationType === 1);

    const verifyOtherLocationTimeUpdate = () => {
        for (let loc of jobLocations) {
            if (
                loc.rlkLocationType !== 2 &&
                loc.rtuDepartureTime === LOCATIONNOTUPDATEDFLAG
            ) {
                return false;
            }
        }
        return true;
    };

    const gridFormHeaders = {
        LOCATION: "Location Form",
        ARRIVAL: "Arrival Actual",
        DEPATURE: "Dep. Actual",
        ARRIVAL_OPTION: "Arrival Option",
        DEPATURE_OPTION: "Dep. Option",
    };

    const gridFields = {
        ARRIVAL: "rtuArrivalTime",
        DEPATURE: "rtuDepartureTime",
    };

    let popUpComponent = <></>;

    console.log(customerId);

    switch (popUpContent) {
        case gridFormHeaders.LOCATION: {
            popUpComponent = (
                <LocationDetails
                    locationId={currentLocation}
                    locationCustomerId={customerId}
                />
            );
            break;
        }

        case gridFormHeaders.ARRIVAL: {
            popUpComponent = (
                <PopUpDateTimePicker
                    key={popUpKey}
                    value={currentArrivalDate}
                    onAccept={(value) => {
                        updateTime(currentId, value, "A", chooseTime_select);
                    }}
                    onCancel={() => modalRef.current.close()}
                    returnJsonDate={true}
                    validators={[
                        {
                            func: (date) =>
                                lastDepartureDate && lastDepartureSeq !== currentSeq
                                    ? isAfter(
                                        date,
                                        addMinutesToDate(lastDepartureDate, timeGapInMins),
                                    )
                                    : true,
                            message:
                                "Date should be after previous location departure date and time gap",
                        },
                        {
                            func: (date) => isBefore(date, new Date()),
                            message: "Date and Time should be before current date and time",
                        },
                    ]}
                />
            );
            break;
        }

        case gridFormHeaders.DEPATURE: {
            popUpComponent = (
                <PopUpDateTimePicker
                    key={popUpKey}
                    value={currentDepartureDate}
                    onAccept={(value) => {
                        updateTime(currentId, value, "D", chooseTime_select);
                    }}
                    onCancel={() => modalRef.current.close()}
                    returnJsonDate={true}
                    validators={[
                        {
                            func: (date) =>
                                isAfter(
                                    date,
                                    addMinutesToDate(currentArrivalDate, timeGapInMins),
                                ),
                            message: "Date should be after arrival date and time gap",
                        },
                        {
                            func: (date) => isBefore(date, new Date()),
                            message: "Date and Time should be before current date and time",
                        },
                    ]}
                />
            );
            break;
        }

        case gridFormHeaders.ARRIVAL_OPTION: {
            popUpComponent = (
                <div className="ui form">
                    <div className="field">
                        <label>Select Arrival Time</label>
                        <select
                            className="ui dropdown"
                            defaultValue=""
                            onChange={(e) => {
                                const selectedValue = e.target.value;
                                modalRef.current.close();

                                if (selectedValue === "CUSTOM") {
                                    setPopUpContent(gridFormHeaders.ARRIVAL);
                                    setPopUpKey((p) => p + 1);
                                    modalRef.current?.showModal();
                                } else if (selectedValue) {
                                    updateTime(currentId, selectedValue, "A", chooseTime_suggest);
                                }
                            }}
                        >
                            <option value="" disabled>
                                Select a Geofence Time
                            </option>

                            {/* Dynamic Geofence Records with conditional coloring and text styling */}
                            {geoArrivalList.map((geo, index) => {
                                const isGPS = geo.createdBy === "GPS";
                                const isDriver = geo.createdBy === "Driver";

                                // Determine text color
                                let optionColor = "inherit";
                                if (isGPS) optionColor = "green";
                                if (isDriver) optionColor = "blue";

                                return (
                                    <option
                                        key={index}
                                        value={geo.ttgTime}
                                        style={{ color: optionColor, fontWeight: "500" }}
                                    >
                                        {geo.createdBy ? `${geo.createdBy} - ` : ""}
                                        {formatDateTime(geo.ttgTime)}
                                    </option>
                                );
                            })}

                            <option value="CUSTOM" style={{ color: "black" }}>Custom Time</option>
                        </select>
                    </div>
                </div>
            );
            break;
        }

        case gridFormHeaders.DEPATURE_OPTION: {
            popUpComponent = (
                <div className="ui form">
                    <div className="field">
                        <label>Select Dep. Time</label>
                        <select
                            className="ui dropdown"
                            defaultValue=""
                            onChange={(e) => {
                                const selectedValue = e.target.value;
                                modalRef.current.close();

                                if (selectedValue === "CUSTOM") {
                                    setPopUpContent(gridFormHeaders.DEPATURE);
                                    setPopUpKey((p) => p + 1);
                                    modalRef.current?.showModal();
                                } else if (selectedValue) {
                                    updateTime(currentId, selectedValue, "D", chooseTime_suggest);
                                }
                            }}
                        >
                            <option value="" disabled>
                                Select a Geofence Time
                            </option>

                            {/* Dynamic Geofence Records with conditional coloring and text styling */}
                            {geoDepartureList.map((geo, index) => {
                                const isGPS = geo.createdBy === "GPS";
                                const isDriver = geo.createdBy === "Driver";

                                // Determine text color
                                let optionColor = "inherit";
                                if (isGPS) optionColor = "green";
                                if (isDriver) optionColor = "blue";

                                return (
                                    <option
                                        key={index}
                                        value={geo.ttgTime}
                                        style={{ color: optionColor, fontWeight: "500" }}
                                    >
                                        {geo.createdBy ? `${geo.createdBy} - ` : ""}
                                        {formatDateTime(geo.ttgTime)}
                                    </option>
                                );
                            })}

                            <option value="CUSTOM" style={{ color: "black" }}>Custom Time</option>
                        </select>
                    </div>
                </div>
            );
            break;
        }

        default:
            popUpComponent = <></>;
    }

    const handleCellClick = async (params) => {
        console.log("params.data", params.data);
        if (
            params.colDef.headerName === gridFormHeaders.ARRIVAL ||
            params.colDef.headerName === gridFormHeaders.DEPATURE
        ) {
            if (timeUpdateViewMode) {
                console.log(jobInfo.statusId);
                toast.warn(
                    vnaList.includes(jobInfo.statusId)
                        ? "Vehicle should be assigned before updating location time"
                        : editDisabledStatus.includes(jobInfo.statusId)
                            ? "Times cannot be updated at this status"
                            : "Cannot update time after Operation Confirm Status",
                    {
                        containerId: "Main",
                        autoClose: 3000,
                    },
                );
                return;
            }
            if (params.data.rlkLocationType !== 1) {
                const firstLocation = findFirstLocation();
                if (firstLocation.rtuDepartureTime === LOCATIONNOTUPDATEDFLAG) {
                    toast.warn(
                        "Start location time should be updated before updating other location time",
                        {containerId: "Main", autoClose: 3000},
                    );
                    return;
                }
            }
            if (params.data.rlkLocationType === 2) {
                console.log(verifyOtherLocationTimeUpdate());
                if (!verifyOtherLocationTimeUpdate()) {
                    toast.warn(
                        "All the Via location times should be updated before updating the End location time",
                        {containerId: "Main", autoClose: 3000},
                    );
                    return;
                }
            }
            if (params.colDef.headerName === gridFormHeaders.ARRIVAL) {
                const editMode = params.data?.rtuArrivalTime !== LOCATIONNOTUPDATEDFLAG;
                const {authorized} = getFieldAuthority(
                    auth,
                    FORMS.JOB.TIME_UPDATE.form,
                    "rtuArrivalTime",
                    false,
                    editMode,
                );
                if (!authorized) {
                    toast.warn(
                        `You don't have permission to ${editMode ? "update" : "set"} arrival time`,
                        {autoClose: 5000, containerId: "Main"},
                    );
                    return;
                }
            }
            if (params.colDef.headerName === gridFormHeaders.DEPATURE) {
                const editMode =
                    params.data?.rtuDepartureTime !== LOCATIONNOTUPDATEDFLAG;
                const {authorized} = getFieldAuthority(
                    auth,
                    FORMS.JOB.TIME_UPDATE.form,
                    "rtuDepartureTime",
                    false,
                    editMode,
                );
                if (!authorized) {
                    toast.warn(
                        `You don't have permission to ${editMode ? "update" : "set"} departure time`,
                        {autoClose: 5000, containerId: "Main"},
                    );
                    return;
                }
            }
            switch (params.colDef.headerName) {
                case gridFormHeaders.ARRIVAL: {
                    const response = await geofenceTimeByRtuId(params.data.rtuId, "A");
                    const hasGeofenceRecords = response && response.length > 0;

                    // Store the entire list in state
                    setGeoArrivalList(hasGeofenceRecords ? response : []);

                    setCurrentId(params.data.id);
                    setCurrentSeq(params.data.actualSeq);
                    setCurrentArrivalDate(params.data.rtuArrivalTimeNonFormat);
                    setCurrentDepartureDate(params.data.rtuDepartureTimeNonFormat);

                    if (hasGeofenceRecords) {
                        setPopUpContent(gridFormHeaders.ARRIVAL_OPTION);
                    } else {
                        setPopUpContent(gridFormHeaders.ARRIVAL);
                    }
                    break;
                }

                case gridFormHeaders.DEPATURE: {
                    const response = await geofenceTimeByRtuId(params.data.rtuId, "D");
                    const hasGeofenceRecords = response && response.length > 0;

                    if (params.data[gridFields.ARRIVAL] === LOCATIONNOTUPDATEDFLAG) {
                        toast.warn(
                            "Please update the arrival time before updating the departure time",
                            { containerId: "Main", autoClose: 3000 },
                        );
                        return;
                    }

                    // Store the entire list in state
                    setGeoDepartureList(hasGeofenceRecords ? response : []);

                    setCurrentId(params.data.id);
                    setCurrentSeq(params.data.actualSeq);
                    setCurrentArrivalDate(params.data.rtuArrivalTimeNonFormat);
                    setCurrentDepartureDate(params.data.rtuDepartureTimeNonFormat);

                    if (hasGeofenceRecords) {
                        setPopUpContent(gridFormHeaders.DEPATURE_OPTION);
                    } else {
                        setPopUpContent(gridFormHeaders.DEPATURE);
                    }
                    break;
                }
                default:
                    return;
            }
        }

        setPopUpKey((prevState) => prevState + 1);
        modalRef.current?.showModal();
    };

    const modalRef = useRef();

    return (
        <div className="segment" style={{padding: "10px"}}>
            {isLoading ? (
                <LoadingSpinner/>
            ) : (
                <>
                    <Modal ref={modalRef} minWidth="0px">
                        {popUpComponent}
                    </Modal>
                    <div className="ui form">
                        <h2>Time Update</h2>

                        <div className="ui segment">
                            <InfoList content={jobInformation} title="Job Information"/>
                            <Grid
                                heading="Update Time"
                                multiRowSelection={true}
                                downloadOnlySelected={false}
                                showDownloadButton={true}
                                gridOptions={{
                                    getRowStyle: (params) => {
                                        if (params.data.rlkLocationType === 1) {
                                            return {background: "#E0F7FA"};
                                        } else if (params.data.rlkLocationType === 2) {
                                            return {background: "#E6F4EA"};
                                        }
                                    },
                                }}
                                config={[
                                    {
                                        headerName: "Location",
                                        field: "locName",
                                        pinned: "left",
                                        module: MODULES.Transaction,
                                        primaryForm: FORMS.JOB.TIME_UPDATE.form,
                                        authenticated: true,
                                        cellRenderer: ResizableScrollingTextRenderer,
                                    },
                                    {
                                        headerName: "Req. Seq",
                                        field: "planedSeq",
                                        sortIndex: 1,
                                        sort: "asc",
                                        module: MODULES.Transaction,
                                        primaryForm: FORMS.JOB.TIME_UPDATE.form,
                                        authenticated: true,
                                    },
                                    {
                                        headerName: "Type",
                                        field: "rlkLocationTypeValue",
                                        module: MODULES.Transaction,
                                        primaryForm: FORMS.JOB.TIME_UPDATE.form,
                                        authenticated: true,
                                        minWidth: 250,
                                    },
                                    {
                                        headerName: "Arrival ETA",
                                        field: "gRlkArrivalEta",
                                        module: MODULES.Transaction,
                                        primaryForm: FORMS.JOB.TIME_UPDATE.form,
                                        authenticated: true,
                                        minWidth: 250,
                                    },
                                    {
                                        headerName: gridFormHeaders.ARRIVAL,
                                        field: "rtuArrivalTime",
                                        module: MODULES.Transaction,
                                        primaryForm: FORMS.JOB.TIME_UPDATE.form,
                                        authenticated: true,
                                        cellRenderer: InputRenderer,
                                        minWidth: 300,
                                        cellRendererParams: (params) => ({
                                            readOnly: true,
                                            value: params.value,
                                            field: "rtuArrivalTime",
                                            style:
                                                params.data.rtuArrivalUpdatedBy === "GPS"
                                                    ? {color: "red", fontWeight: "bold"}
                                                    : params.data?.rtuArrivalTime &&
                                                    params.data?.rtuATimeSuggestedType === "SUGGESTED"
                                                        ? {color: "blue", fontWeight: "bold"}
                                                        : {},
                                            module: MODULES.Transaction,
                                            form: FORMS.JOB.TIME_UPDATE.form,
                                            editMode: !!currentArrivalDate,
                                            authenticated: true,
                                        }),
                                    },
                                    {
                                        headerName: "Dep. ETA",
                                        field: "gRlkDepartureEta",
                                        module: MODULES.Transaction,
                                        primaryForm: FORMS.JOB.TIME_UPDATE.form,
                                        authenticated: true,
                                        minWidth: 250,
                                    },
                                    {
                                        headerName: gridFormHeaders.DEPATURE,
                                        field: "rtuDepartureTime",
                                        module: MODULES.Transaction,
                                        primaryForm: FORMS.JOB.TIME_UPDATE.form,
                                        authenticated: true,
                                        cellRenderer: InputRenderer,
                                        minWidth: 300,
                                        cellRendererParams: (params) => ({
                                            readOnly: true,
                                            value: params.value,
                                            style:
                                                params.data.rtuDepartureUpdatedBy === "GPS"
                                                    ? {color: "red", fontWeight: "bold"}
                                                    : params.data?.rtuDepartureTime !== null &&
                                                    params.data?.rtuDTimeSuggestedType === "SUGGESTED"
                                                        ? {color: "blue", fontWeight: "bold"}
                                                        : {},

                                            field: "rtuDepartureTime",
                                            module: MODULES.Transaction,
                                            form: FORMS.JOB.TIME_UPDATE.form,
                                            editMode: !!currentDepartureDate,
                                            authenticated: true,
                                        }),
                                    },
                                    {
                                        headerName: "Actual Seq",
                                        field: "actualSeq",
                                        module: MODULES.Transaction,
                                        primaryForm: FORMS.JOB.TIME_UPDATE.form,
                                        authenticated: true,
                                        sortIndex: 0,
                                        sortable: true,
                                        sort: "asc",
                                        sortingOrder: ["asc", null],
                                        comparator: (a, b) => {
                                            const va = Number(a);
                                            const vb = Number(b);

                                            const aIsZeroish = !Number.isFinite(va) || va === 0;
                                            const bIsZeroish = !Number.isFinite(vb) || vb === 0;

                                            if (aIsZeroish && bIsZeroish) return 0;

                                            if (aIsZeroish) return 1;
                                            if (bIsZeroish) return -1;

                                            return va - vb;
                                        },
                                        pinned: "right",
                                    },
                                ]}
                                content={jobLocations}
                                onRowDoubleClicked={(params) => {
                                    setCurrentLocation(params.data.lcuId);
                                    setPopUpContent(gridFormHeaders.LOCATION);
                                    setPopUpKey((prevState) => prevState + 1);
                                    modalRef.current?.showModal();
                                }}
                                cellClickHandler={handleCellClick}
                            />
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default TimeUpdate;
